import { useContext, useEffect } from "react";
import { RiSteering2Line } from "react-icons/ri";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Awards from "./screens/Awards";
import Channel from "./screens/Channel";
import Detail from "./screens/Detail";
import Gallery from "./screens/Gallery";
import Home from "./screens/Home";
import Outlets from "./screens/Outlets";
import Thankyou from "./screens/Thankyou";
import Contact from "./screens/contact";
import BookAService from "./screens/services/book";
import Finance from "./screens/services/finance";
import Insurance from "./screens/services/insurance";
import Truevalue from "./screens/services/truevalue";

import { HiMiniWrenchScrewdriver } from "react-icons/hi2";
import whatsappSvg from "./assets/whatsapp.svg";
import Blogs from "./components/Blogs";
import About from "./screens/About";
import Offers from "./screens/Offers";
import PrivacyPolicy from "./screens/services/PrivacyPolicy";
import DrivingSchool from "./screens/services/driving-school";
import SellCar from "./screens/truevalue/sellCar";
import BuyCar from "./screens/truevalue/truevaluebuy";
import Login from "./screens/auth/login";
import { AuthContext } from "./context/auth-context";
import Dashboard from "./screens/admin/dashboard";
import Leads from "./screens/admin/leads";
import AdminTruevalue from "./screens/admin/truevalue";
import FinanceLeads from "./screens/admin/finance";

function App() {
  const { currentUser } = useContext(AuthContext);

  const ProtectedRoute = ({ children }) => {
    return currentUser ? children : <Navigate to="/" />;
  };

  const ScrollTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
    return null;
  };
  const location = useLocation();

  // ✅ Detect all vehicle detail pages
  const isVehicleDetailPage = location.pathname.startsWith("/vehicles/");
  const isAdminPage = location.pathname.startsWith("/admin");
  const isLoginPage = location.pathname.startsWith("/login");
  return (
    <div className="">
      <ScrollTop />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/vehicles/:id" element={<Detail />} />
        {/* <Route path="/vehicles/e-vitara" element={<EVitara />} /> */}
        <Route path="/channels/:id" element={<Channel />} />
        <Route path="/book-a-service" element={<BookAService />} />
        <Route path="/finance" element={<Finance />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/truevalue" element={<Truevalue />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/thank-you" element={<Thankyou />} />
        <Route path="/awards" element={<Awards />} />
        <Route path="/used-cars-sale" element={<BuyCar />} />
        <Route path="/sell-old-cars" element={<SellCar />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/outlets" element={<Outlets />} />
        <Route path="/driving-school" element={<DrivingSchool />} />
        <Route path="*" element={"404 - Not Found"} />

        {/* ===========Admin authentication=========== */}
        <Route path="/login" element={<Login />} />

        {/* ===========admin routes=========== */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/leads"
          element={
            <ProtectedRoute>
              <Leads />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/truevalue"
          element={
            <ProtectedRoute>
              <AdminTruevalue />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/finance"
          element={
            <ProtectedRoute>
              <FinanceLeads />
            </ProtectedRoute>
          }
        />
      </Routes>

      {!isVehicleDetailPage && !isAdminPage && !isLoginPage && (
        <>
          <div className="fixed z-20 space-y-2 -translate-y-1/2 right-1 bottom-1/3 lg:right-0 ">
            <Link
              to={"/book-a-service"}
              className="flex items-center flex-grow gap-2 px-4 py-2 text-sm text-center text-white duration-300 delay-100 translate-x-32 bg-[#2E2583] border border-[#2E2583] rounded-l-full shadow-lg cursor-pointer hover:translate-x-0 group"
            >
              <HiMiniWrenchScrewdriver className="h-5 w-5" />

              <p className="opacity-0 group-hover:opacity-100">
                {" "}
                Book A Service
              </p>
            </Link>
            <Link
              to={"/contact-us"}
              className="flex items-center flex-grow gap-2 px-4 py-2 text-sm text-center text-white duration-300 delay-100 translate-x-32 bg-[#2E2583] border border-[#2E2583] rounded-l-full shadow-lg cursor-pointer hover:translate-x-0 group"
            >
              <RiSteering2Line className="h-6 w-6" />

              <p className="opacity-0 group-hover:opacity-100">
                {" "}
                Book A Test Drive
              </p>
            </Link>
          </div>

          <div className="fixed bottom-5 right-5 z-[9999]">
            <a
              href="https://api.whatsapp.com/send/?phone=+919912341531&text=Hello%20%F0%9F%91%8B%20Welcome%20to%20GEM%20Motors!%20What's%20your%20name%3F&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="bg-green-600 p-2.5 rounded-full animate-bounce">
                <img
                  src={whatsappSvg}
                  loading="lazy"
                  className="h-6 w-6"
                  alt="whatsapp"
                />
              </div>
            </a>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
